const PHRASES = [
  "Business Strategy",
  "Investment Opportunity Analysis",
  "Deal Evaluation",
  "Wealth-Building Strategies",
  "Entrepreneurial Growth",
];

export default function Marquee() {
  const items = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-white/10 bg-[#0A0A0D] py-5"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {items.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap px-8 text-xs font-medium uppercase tracking-[0.34em] text-[#8C7139]">
                  {p}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-[#C5A059]/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
